import { Individual, IndividualCallback, Sex } from '../Data';
import { lifetimeOf } from '../Utils';
import styles from './TreeNode.module.css';

interface TreeNodeProps {
    individual: Individual;
    showDetails: IndividualCallback;
    isExpanded: boolean;
    hasChildren: boolean;
    onToggle: () => void;
    depth: number;
    isAncestor?: boolean;
}

export function TreeNode({
    individual,
    showDetails,
    isExpanded,
    hasChildren,
    onToggle,
    depth,
    isAncestor = false,
}: TreeNodeProps) {
    const sexIcon = individual.sex === Sex.Male ? '♂' : individual.sex === Sex.Female ? '♀' : '?';
    const expandIcon = hasChildren ? (isExpanded ? '▼' : '▶') : '•';

    const nodeClass = [
        styles.node,
        isAncestor ? styles.ancestor : styles.descendant,
    ].join(' ');

    return (
        <div
            className={nodeClass}
            style={{ '--depth': depth } as React.CSSProperties}
        >
            <div className={styles.content}>
                {hasChildren ? (
                    <button
                        className={styles.toggleButton}
                        onClick={onToggle}
                        aria-expanded={isExpanded}
                        aria-label={isExpanded ? 'Collapse' : 'Expand'}
                    >
                        {expandIcon}
                    </button>
                ) : (
                    <span className={styles.togglePlaceholder}>{expandIcon}</span>
                )}
                <button
                    className={styles.nameButton}
                    onClick={() => showDetails(individual.id)}
                >
                    <span className={styles.sexIcon}>{sexIcon}</span>
                    <span className={styles.name}>
                        {individual.lastName}, {individual.firstNames}
                    </span>
                    <span className={styles.lifetime}>
                        ({lifetimeOf(individual)})
                    </span>
                </button>
            </div>
        </div>
    );
}

interface SpouseNodeProps {
    individual: Individual;
    showDetails: IndividualCallback;
    depth: number;
}

export function SpouseNode({ individual, showDetails, depth }: SpouseNodeProps) {
    const sexIcon = individual.sex === Sex.Male ? '♂' : individual.sex === Sex.Female ? '♀' : '?';

    return (
        <div
            className={`${styles.node} ${styles.spouse}`}
            style={{ '--depth': depth } as React.CSSProperties}
        >
            <div className={styles.content}>
                <span className={styles.togglePlaceholder}>♡</span>
                <button
                    className={styles.nameButton}
                    onClick={() => showDetails(individual.id)}
                >
                    <span className={styles.sexIcon}>{sexIcon}</span>
                    <span className={styles.name}>
                        {individual.lastName}, {individual.firstNames}
                    </span>
                    <span className={styles.lifetime}>
                        ({lifetimeOf(individual)})
                    </span>
                </button>
                <span className={styles.spouseLabel}>(spouse)</span>
            </div>
        </div>
    );
}
